document.documentElement.classList.remove('no-js');

document.addEventListener('change', function (event) {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const root = form.closest('[data-product-root], .mv-offer-card');
  const price = root && root.querySelector('[data-product-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});

function initProductGallery(gallery) {
  if (!gallery || gallery.dataset.galleryReady === 'true') return;

  const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  const previousButton = gallery.querySelector('[data-gallery-prev]');
  const nextButton = gallery.querySelector('[data-gallery-next]');
  const counter = gallery.querySelector('[data-gallery-counter]');
  const viewport = gallery.querySelector('[data-gallery-viewport]');

  if (!slides.length) return;

  let currentIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
  let touchStartX = 0;

  function showSlide(index, moveFocus) {
    currentIndex = (index + slides.length) % slides.length;

    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === currentIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    thumbs.forEach((thumb, thumbIndex) => {
      const isActive = thumbIndex === currentIndex;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        if (moveFocus) thumb.focus({ preventScroll: true });
      }
    });

    if (counter) counter.textContent = `${currentIndex + 1} / ${slides.length}`;
  }

  thumbs.forEach((thumb, thumbIndex) => {
    thumb.addEventListener('click', () => showSlide(thumbIndex, false));
  });

  if (previousButton) previousButton.addEventListener('click', () => showSlide(currentIndex - 1, false));
  if (nextButton) nextButton.addEventListener('click', () => showSlide(currentIndex + 1, false));

  gallery.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showSlide(currentIndex - 1, false);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      showSlide(currentIndex + 1, false);
    }
  });

  if (viewport && slides.length > 1) {
    viewport.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    viewport.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) < 45) return;
      showSlide(distance > 0 ? currentIndex - 1 : currentIndex + 1, false);
    }, { passive: true });
  }

  gallery.dataset.galleryReady = 'true';
  showSlide(currentIndex, false);
}

function initProductGalleries(root) {
  (root || document).querySelectorAll('[data-product-gallery]').forEach(initProductGallery);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProductGalleries(document));
} else {
  initProductGalleries(document);
}

document.addEventListener('shopify:section:load', (event) => initProductGalleries(event.target));